import React, { useEffect, useRef, useState } from 'react';

const Composer = ({ onSend, onTyping, canPostNotes = true }) => {
  const tabs = [
    { key:'chat', label:'Chat' },
    ...(canPostNotes ? [{ key:'note', label:'Note' }] : []),
    // Email reserved for later phase
  ];
  const [active, setActive] = useState('chat');
  const [text, setText] = useState('');
  const [busy, setBusy] = useState(false);

  const idleTimerRef = useRef(null);
  const debounceRef = useRef(null);
  const typingActiveRef = useRef(false);

  useEffect(() => {
    // Debounce typing signal to reduce chatter
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => { onTyping && onTyping(!!text); typingActiveRef.current = !!text; }, 120);

    // Restart idle timer to auto-send stop typing when user pauses
    if (idleTimerRef.current) clearTimeout(idleTimerRef.current);
    idleTimerRef.current = setTimeout(() => { onTyping && onTyping(false); typingActiveRef.current = false; }, 1800);

    return () => {
      if (debounceRef.current) clearTimeout(debounceRef.current);
    };
  }, [text, onTyping]);

  useEffect(() => {
    // On unmount, make sure to signal not typing
    return () => { onTyping && onTyping(false); typingActiveRef.current = false; };
  }, [onTyping]);

  const send = async () => {
    if (!text.trim()) return;
    setBusy(true);
    try {
      await onSend?.({ channel: active, text, internal: active === 'note' });
      setText('');
      onTyping && onTyping(false);
    } finally { setBusy(false); }
  };

  return (
    <div className="composer">
      <div className="tabs">
        {tabs.map(t => (
          <button key={t.key} className={active===t.key?'active':''} onClick={()=>setActive(t.key)}>{t.label}</button>
        ))}
      </div>
      <textarea
        placeholder={active==='note' ? 'Write an internal note…' : 'Write a message…'}
        value={text}
        onChange={(e)=>setText(e.target.value)}
        onKeyDown={(e)=>{
          // Fire start typing immediately on first keydown
          if (!typingActiveRef.current && e.key.length === 1) {
            onTyping && onTyping(true);
            typingActiveRef.current = true;
            if (idleTimerRef.current) clearTimeout(idleTimerRef.current);
            idleTimerRef.current = setTimeout(() => { onTyping && onTyping(false); typingActiveRef.current = false; }, 1800);
          }
          if(e.key==='Enter' && (e.ctrlKey || e.metaKey)) { e.preventDefault(); send(); }
        }}
        onBlur={() => { onTyping && onTyping(false); typingActiveRef.current = false; }}
      />
      <div className="actions">
        <div className="left">
          {/* attachments or emoji in future */}
        </div>
        <div className="right">
          <button onClick={send} disabled={busy || !text.trim()}>{busy ? 'Sending…' : 'Send'}</button>
        </div>
      </div>
    </div>
  );
};

export default Composer;
